export default __webpack_public_path__ + "static/media/caen3.313c1f45.jpg";